module.exports = __webpack_public_path__ + "static/media/pomegranate.e3947acb.png";